import React from 'react'
import { twMerge } from 'tailwind-merge'

export enum RoundIconComponentEnum {
  Small = 'small',
  Medium = 'medium',
}

export const RoundIconComponent = ({
  children,
  className,
  size = RoundIconComponentEnum.Medium,
}: {
  children: React.ReactNode
  className?: string
  size?: RoundIconComponentEnum
}) => {
  return (
    <div
      className={twMerge(
        'rounded-full',
        size === RoundIconComponentEnum.Small &&
          'h-6 w-6 p-2 [&>svg]:h-[11px] [&>svg]:w-[11px]',
        size === RoundIconComponentEnum.Medium &&
          'h-10 w-10 p-3 [&>svg]:h-5 [&>svg]:w-5',
        className,
      )}
    >
      <div className="flex h-full w-full items-center justify-center">
        {children}
      </div>
    </div>
  )
}
